<template>
  <div class="page">
    <div class="partner">
      <div class="partner-top">
        <div class="partnerTitle">{{ props.data.titleCn }}</div>
        <div class="partnerEn">{{ props.data.titleEn }}</div>
        <div class="partner-desc">（排序不分先后）</div>
      </div>
      <div class="partner-bottom">
        <div class="bottom-list">
          <div class="list-item" v-for="(item, index) in props.data.list" :key="index">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-photos">
              <div v-for="(child, indexa) in item.photos" :key="indexa" class="photo-item">
                <img :src="child" alt="" class="photo-img" />
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})
</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 20px;
  .partner {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 72px;
    .partner-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .partnerTitle {
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 32px;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .partnerEn {
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 12px;
      }
      .partner-desc{
        color: rgba(44, 44, 44, 1);
        font-family: Microsoft YaHei;
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        letter-spacing: 0px;
        margin-top: 20px;
      }
    }
    .partner-bottom{
      width: 100%;
      .bottom-list{
        width: 100%;
        display: flex;
        flex-direction: column;
        .list-item{
          width: 100%;
          display: flex;
          flex-direction: column;
          margin-top: 32px;
          .item-title{
            color: rgba(44, 44, 44, 1);
            font-family: Microsoft YaHei;
            font-size: 18px;
            font-weight: 600;
            line-height: 18px;
            letter-spacing: 0px;
            margin-bottom: 18px;
          }
          .item-photos{
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 12px;
            .photo-item{
              width: 100%;
              height: 50px;
              background: rgba(255, 255, 255, 1);
              display: flex;
              align-items: center;
              justify-content: center;
              .photo-img{
                max-height: 32px;
                max-width: 80%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
